import { HTTP_METHODS } from '@studio/constants/axios';
import { AI_API_V1 } from '@studio/constants/env-variables';
import type { AI } from '@studio/types';

export const root = {
  [HTTP_METHODS.POST]: {
    url: `${AI_API_V1}/subtitles/@id/content`,
    response: {} as AI.Post.ContentResponse,
    params: {} as { id: string },
    request: {} as { types: AI.AIGenContentTypes[] },
    method: HTTP_METHODS.POST,
  },
};

export const id = {};
